<script lang="ts">
      import { randomString } from '$lib/utils/random'
      import { untrack } from 'svelte'
      import Check from './Check.svelte'

      let id = randomString(9)
      let _checked = $state(false)

      let { children = undefined, checked = $bindable(), blocked = null } = $props()

      $effect( () => {
        _checked
        untrack( () => {
          if( blocked != null ) _checked = blocked
          checked = _checked
        })
      })

</script>

<label for={id} class="checkbox flex items-center gap-4">
      <div class="flex aspect-square h-[2rem] rounded-full bg-[#ffffff] border-2 border-[#616161]">
            <input bind:checked={_checked} {id} name={id} type="checkbox" class="hidden" />
            <Check class="fill-[#616161]"></Check>
      </div>
      <p>{@render children?.()}</p>
</label>

<style lang="postcss">
      .checkbox input[type='checkbox'] + :global(*) {
            @apply opacity-0;
            transition: opacity 0.17s ease-in-out;
      }

      .checkbox input[type='checkbox']:checked + :global(*) {
            @apply opacity-100;
      }
</style>
